import type { SVGProps } from 'react';
const SvgOnOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#on-off_svg__a)">
      <path
        fill="#000"
        d="M12 4.667a7.333 7.333 0 1 0 0 14.667 7.333 7.333 0 0 0 0-14.667ZM11.333 8a.667.667 0 0 1 1.334 0v2.667a.667.667 0 0 1-1.334 0V8Zm3.967 7.3a4.667 4.667 0 0 1-6.6-6.6.667.667 0 0 1 .94 0 .652.652 0 0 1 0 .94 3.333 3.333 0 1 0 4.72 0 .652.652 0 0 1 0-.94.667.667 0 0 1 .94 0 4.666 4.666 0 0 1 0 6.6Z"
      />
    </g>
    <defs>
      <clipPath id="on-off_svg__a">
        <path fill="currentColor" d="M4 4h16v16H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOnOff;
